// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"c3836fb1","147":"9fe9b391","438":"39bbd81a","706":"639e8260","726":"0ab395d2","790":"3f2a4bec"}[chunkId] + ".chunk.js";
};